import { useRecordContext } from 'react-admin'

import { Link, Tooltip } from '@mui/material'
// import SendIcon from '@mui/icons-material/Send'

export const TelegramLinkField = ({ source }) => {
  const record = useRecordContext()
  if (!record) return null

  const username = record[source]
  const telegramLink = `https://t.me/${username}`

  return (
    <Tooltip title={`Send message to ${username}`}>
      <Link href={telegramLink} target="_blank" rel="noopener noreferrer">
        {username}
        {/* <SendIcon size={16} style={{ verticalAlign: 'middle', marginLeft: '4px' }} /> */}
      </Link>
    </Tooltip>
  )
}
